<template>
  <div id='unit-convert'>
      <div style="text-align: center;font-weight: 700;margin:20px 0;">
        <p>电场强度单位换算</p>
      </div>
      <div id="unquickcalc" style="display:none;"></div>
      <div id="ucresult" class="ucresulttext"></div>
      <form>
        <table id="uctable">
            <tr>
                <td class="uccell">
                    <label for="ucfrom">From:</label>
                    <br>
                    <input type="text" name="ucfrom" class="ucinput" id="ucfrom" onKeyUp="ucUpdateResult();" autofocus>
                </td>
                <td class="uccell">
                    <label for="ucto">To:</label>
                    <br>
                    <input type="text" name="ucto" class="ucinput" id="ucto" style="background-color:#eeeeee;" readonly>
                </td>
            </tr>
            <tr>
                <td class="uccell">
                  <select name="ucfromunit" id="ucfromunit" size="13" onChange="ucUpdateResult();" class="ucselect">
                      <option value="volt/meter [V/m] [10000000]" selected>volt/meter [V/m]</option>
                      <option value="kilovolt/meter [kV/m] [10000]">kilovolt/meter [kV/m]</option>
                      <option value="kilovolt/centimeter [kV/cm] [100]">kilovolt/centimeter [kV/cm]</option>
                      <option value="volt/centimeter [V/cm] [100000]">volt/centimeter [V/cm]</option>
                      <option value="millivolt/meter [mV/m] [10000000000]">millivolt/meter [mV/m]</option>
                      <option value="microvolt/meter [&#181;/m] [10000000000000]">microvolt/meter [&#181;/m]</option>
                      <option value="kilovolt/inch [kV/in] [254]">kilovolt/inch [kV/in]</option>
                      <option value="volt/inch [V/in] [254000]">volt/inch [V/in]</option>
                      <option value="volt/mil [V/mil] [254]">volt/mil [V/mil]</option>
                      <option value="abvolt/centimeter [abV/cm] [10000000000000]">abvolt/centimeter [abV/cm]</option>
                      <option value="statvolt/centimeter [stV/cm] [333.5646048]">statvolt/centimeter [stV/cm]</option>
                      <option value="statvolt/inch [stV/in] [847.2540962]">statvolt/inch [stV/in]</option>
                      <option value="newton/coulomb [N/C] [10000000]">newton/coulomb [N/C]</option>
                  </select>
                </td>
                <td class="uccell">
                  <select name="uctounit" id="uctounit" size="13" onChange="ucUpdateResult();" class="ucselect">
                      <option value="volt/meter [V/m] [10000000]">volt/meter [V/m]</option>
                      <option value="kilovolt/meter [kV/m] [10000]" selected>kilovolt/meter [kV/m]</option>
                      <option value="kilovolt/centimeter [kV/cm] [100]">kilovolt/centimeter [kV/cm]</option>
                      <option value="volt/centimeter [V/cm] [100000]">volt/centimeter [V/cm]</option>
                      <option value="millivolt/meter [mV/m] [10000000000]">millivolt/meter [mV/m]</option>
                      <option value="microvolt/meter [&#181;/m] [10000000000000]">microvolt/meter [&#181;/m]</option>
                      <option value="kilovolt/inch [kV/in] [254]">kilovolt/inch [kV/in]</option>
                      <option value="volt/inch [V/in] [254000]">volt/inch [V/in]</option>
                      <option value="volt/mil [V/mil] [254]">volt/mil [V/mil]</option>
                      <option value="abvolt/centimeter [abV/cm] [10000000000000]">abvolt/centimeter [abV/cm]</option>
                      <option value="statvolt/centimeter [stV/cm] [333.5646048]">statvolt/centimeter [stV/cm]</option>
                      <option value="statvolt/inch [stV/in] [847.2540962]">statvolt/inch [stV/in]</option>
                      <option value="newton/coulomb [N/C] [10000000]">newton/coulomb [N/C]</option>
                  </select>
                </td>
            </tr>
        </table>
    </form>
  </div>
</template>
<script>
export default {
  mounted(){
  }
}
</script>
<style scoped>
#unit-convert{
  height: calc(100vh - 125px);
}
</style>
